"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExchangeType = exports.DeviceModel = exports.TokenStandard = exports.CurrencyType = exports.FeesLevel = void 0;
/**
 * Abstract level of fees for a transaction
 */
var FeesLevel;
(function (FeesLevel) {
    FeesLevel["Slow"] = "slow";
    FeesLevel["Medium"] = "medium";
    FeesLevel["Fast"] = "fast";
})(FeesLevel = exports.FeesLevel || (exports.FeesLevel = {}));
/**
 * Currency types
 */
var CurrencyType;
(function (CurrencyType) {
    CurrencyType["CryptoCurrency"] = "CryptoCurrency";
    CurrencyType["TokenCurrency"] = "TokenCurrency";
})(CurrencyType = exports.CurrencyType || (exports.CurrencyType = {}));
/**
 * Token standards
 */
var TokenStandard;
(function (TokenStandard) {
    TokenStandard["ERC20"] = "ERC20";
})(TokenStandard = exports.TokenStandard || (exports.TokenStandard = {}));
var DeviceModel;
(function (DeviceModel) {
    /**
     * Represents the Ledger Blue hardware device
     */
    DeviceModel["Blue"] = "blue";
    /**
     * Represents the Ledger Nano S hardware device
     */
    DeviceModel["NanoS"] = "nanoS";
    /**
     * Represents the Ledger Nano X hardware device
     */
    DeviceModel["NanoX"] = "nanoX";
})(DeviceModel = exports.DeviceModel || (exports.DeviceModel = {}));
/**
 * Enum describing the different types of exchanges.
 */
var ExchangeType;
(function (ExchangeType) {
    ExchangeType[ExchangeType["SWAP"] = 0] = "SWAP";
    ExchangeType[ExchangeType["SELL"] = 1] = "SELL";
    ExchangeType[ExchangeType["FUND"] = 2] = "FUND";
})(ExchangeType = exports.ExchangeType || (exports.ExchangeType = {}));
